<template>
  <div class="info-marker" :style="{ top: (top || 0) + 'px', right: (right || 0) + 'px' }" />
</template>

<script>
export default {
  name: "InfoMarker",
  props: {
    top: { type: Number, default: 0 },
    right: { type: Number, default: 0 },
  },
};
</script>

<style lang="scss">
@use "@/colors" as c;

.info-marker {
  pointer-events: none;
  position: absolute;
  box-sizing: border-box;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background: c.$btn-danger-bg;
  border: 2px solid rgb(255 255 255 / 50%);
}
</style>
